import React from "react";
import {
	DataGridPro,
	GridColumns,
	GridRenderCellParams,
	GridToolbar,
	useGridApiRef,
} from "@mui/x-data-grid-pro";
import { Box, Chip } from "@material-ui/core";
import { schedulesDataGridProps } from "./SchedulesDataGrid.d";

const SchedulesDataGrid: React.FC<schedulesDataGridProps> = (props: schedulesDataGridProps) => {
	const { schedules,
		onRowsSelected,
		rowSelection
	} = props;
	const apiRef = useGridApiRef();

	const setRowSelection = (e) => {
		onRowsSelected(e[0]);
	}

	const orderColumns: GridColumns = [
		{ field: "name", headerName: "Name", width: 150, disableColumnMenu: true },
		{ field: "frequency", headerName: "Frequency", width: 100, disableColumnMenu: true, resizable: false },
		{ field: "runTime", headerName: "Time", width: 100, disableColumnMenu: true, resizable: false },
		{ field: "sourceLocationId", headerName: "Location", width: 80, disableColumnMenu: true, resizable: false },
		{ field: "sourceLocationName", headerName: "Location", width: 120, disableColumnMenu: true },
		{
			field: "destinationLocations",
			headerName: "Destinations",
			width: 120,
			disableColumnMenu: true,
			resizable: false,
			renderCell: (params: GridRenderCellParams) => <Chip variant="outlined" label={params.row.destinationLocations?.length} color="primary" size="small" />,
		},
		{
			field: "departments",
			headerName: "Departments",
			width: 120,
			disableColumnMenu: true,
			renderCell: (params: GridRenderCellParams) => {
				return (
					<Box>
						{params.row.criteria?.criterias?.departmentIds?.map((departmentId, idx) => {
							return (
								<Chip key={idx} label={departmentId} size="small" />
							)
						})}
					</Box>
				)
			},
		},
		{
			field: "productGroups",
			headerName: "Groups",
			width: 120,
			disableColumnMenu: true,
			renderCell: (params: GridRenderCellParams) => {
				return (
					<Box>
						{params.row.criteria?.criterias?.productGroupIds?.map((productGroupId, idx) => {
							return (
								<Chip key={idx} label={productGroupId} size="small"/>
							)
						})}
					</Box>
				)
			},
		},
		{
			field: "seasons",
			headerName: "Seasons",
			width: 120,
			disableColumnMenu: true,
			renderCell: (params: GridRenderCellParams) => {
				return (
					<Box>
						{params.row.criteria?.criterias?.seasonIds?.map((seasonId, idx) => {
							return (
								<Chip key={idx} label={seasonId} size="small"/>
							)
						})}
					</Box>
				)
			},
		},
		{ field: "destinationLocationNames", headerName: "Dest. Locations", width: 120, disableColumnMenu: true, resizable: true, hide: true },

	];

	return (
		<DataGridPro
			apiRef={apiRef}
			autoHeight
			density="compact"
			rows={schedules ?? []}
			columns={orderColumns}
			paginationMode="client"
			rowsPerPageOptions={[25, 50, 100]}
			pagination
			onSelectionModelChange={(i) => setRowSelection(i)}
			selectionModel={rowSelection}
			components={{
				Toolbar: GridToolbar,
			}}
			initialState={{
				pagination: {
					pageSize: 25,
				},
			}}
		/>
	);
};

export default SchedulesDataGrid;
